document.addEventListener('DOMContentLoaded', function () {

    let sliderElement = document.getElementById('collection_filter_nav_slider');
  
    if (sliderElement) {
      let slides = sliderElement.querySelectorAll('.splide__slide');
      let showArrows = slides.length > 1;

      const collectionNavSlider = new Splide('#collection_filter_nav_slider', {
        type: 'slide',
        perPage: 8,
  // omitEnd: true, // Removed to allow last slide to be reached
  focus: 'end',
        pagination: false,
        drag: 'free',
        snap: true,
        gap: '1rem',
        padding: { left: 0, right: 0 },
        lazyLoad: false,
        flickPower: 300,
        arrows: showArrows,
        breakpoints: {
          1440: { perPage: 7 }, 
          1280: { perPage: 5 },
          1024: { perPage: 4 },
          768:  { perPage: 3 },
          640:  { perPage: 2, padding: { left: 0, right: 0 } }
        }
      });

      collectionNavSlider.mount();
    } 

  });

  (function(){
    // Keep a reference to the Splide instance so we can destroy/recreate when needed
    let splideInstance = null;

    function initCollectionFilterNavSlider() {
      const sliderElement = document.getElementById('collection_filter_nav_slider');
      if (!sliderElement) return null;

      const slides = sliderElement.querySelectorAll('.splide__slide');
      const showArrows = slides.length > 1;

      // If already initialized, destroy previous instance
      try {
        if (splideInstance && typeof splideInstance.destroy === 'function') {
          splideInstance.destroy();
          splideInstance = null;
          sliderElement.dataset.splideInitialized = '';
        }
      } catch (err) {
        console.warn('collection-filter-nav-slider: failed to destroy existing instance', err);
      }

      try {
        splideInstance = new Splide('#collection_filter_nav_slider', {
          type: 'slide',
          perPage: 8,
          // omitEnd: true, // Removed to allow last slide to be reached
          focus: 'end',
          pagination: false,
          drag: 'free',
          snap: true,
          gap: 1,
          padding: { left: 0, right: 0 },
          lazyLoad: false,
          flickPower: 300,
          arrows: showArrows,
          breakpoints: {
            1440: { perPage: 7 },
            1280: { perPage: 5 },
            1024: { perPage: 4 },
            768:  { perPage: 3 },
            640:  { perPage: 2, padding: { left: 0, right: 0 } }
          }
        });

        splideInstance.mount();
        sliderElement.dataset.splideInitialized = 'true';
        return splideInstance;
      } catch (err) {
        console.warn('collection-filter-nav-slider: initialization failed', err);
        return null;
      }
    }

    // Expose globally so other scripts can call when re-rendering occurs
    window.initCollectionFilterNavSlider = initCollectionFilterNavSlider;

    document.addEventListener('DOMContentLoaded', function () {
      initCollectionFilterNavSlider();
    });
  })();